import { Card, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Booth, Room } from '../../../../../../../../interfaces/interfaces';
import { getBoothReporting } from '../../../../../../../../services/services';
interface DataShares {
  email: string;
  message: string;
  name: string;
}

interface BoothOpens {
  time: string;
  timeString: string;
  value: number;
}

interface UsersPerRoom {
  count: number;
  meetingroom: Room;
  _id: string;
}

interface BoothReporting {
  boothOpens: BoothOpens[];
  datashares: DataShares[];
  usersPerRoom: UsersPerRoom[];
}
export const BoothReportingStats = ({ booth }: { booth: Booth }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [boothReporting, setBoothReporting] = useState<BoothReporting>({
    boothOpens: [],
    datashares: [],
    usersPerRoom: [],
  });

  const { t } = useTranslation('stats');
  type BoothOpenChartsProps = any;
  const BoothOpenCharts = ({ ...props }: BoothOpenChartsProps) => {
    return (
      <>
        <Paper elevation={3}>
          <div className="m-2 p-4">
            <Typography className="font-size: 1rem;line-height: 1.5rem; capitalize" color="textSecondary" gutterBottom>
              {t('stats:opening-process-status')}
            </Typography>
            <Typography className="font-size: 1rem;line-height: 1.5rem;" color="textSecondary" gutterBottom>
              {t('stats:total-on-event')} {props?.data?.map((el: any) => el.value).reduce((pv: any, cv: any) => pv + cv, 0) || 0}
            </Typography>
          </div>
          <div className="m-auto justify-center items-center" style={{ width: '80%', height: 300 }}>
            <ResponsiveContainer>
              <LineChart {...props}>
                <Line type="monotone" dataKey="value" name="Anzahl" stroke="#8884d8" />
                <CartesianGrid stroke="#ccc" />
                <XAxis dataKey="timeString" />
                <YAxis />
                <Tooltip />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </Paper>
      </>
    );
  };

  useEffect(() => {
    fetchData();
  }, [booth]);

  async function fetchData() {
    setIsLoading(true);
    try {
      if (booth) {
        const boothreporting = await getBoothReporting(booth._id);
        setBoothReporting(boothreporting);
      }
    } catch (err) {
      console.error(err);
    }
    setIsLoading(false);
  }

  if (isLoading)
    return (
      <Card className="w-full" elevation={3}>
        <div className="text-center m-4">
          <Skeleton animation="wave" height={30} width="60%" style={{ marginBottom: 6 }} />
          <Skeleton animation="wave" height={30} width="20%" style={{ marginBottom: 6 }} />
        </div>
      </Card>
    );

  return (
    <>
      {boothReporting.boothOpens.length > 0 ? <BoothOpenCharts data={boothReporting.boothOpens} width={800} height={300} /> : <div />}
      {boothReporting.usersPerRoom.length > 0 && (
        <div className="mb-2 mt-8">
          <TableContainer elevation={3} component={Paper}>
            <div className="ml-2 mt-4 mb-2 pl-4">
              <Typography className="font-size: 1rem;line-height: 1.5rem; capitalize" color="textSecondary" gutterBottom>
                {t('visitor-per-room')}
              </Typography>
            </div>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">{t('room')}</TableCell>
                  <TableCell align="left">{t('roomtype')}</TableCell>
                  <TableCell align="right">{t('amount')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {boothReporting.usersPerRoom.map((upr) => (
                  <TableRow key={upr._id}>
                    <TableCell align="left">{upr.meetingroom.meetingtype === 'meeting' ? upr.meetingroom.contactperson : upr.meetingroom.name}</TableCell>
                    <TableCell align="left">{upr.meetingroom.meetingtype === 'meeting' ? 'Beratung' : 'Vortrag'}</TableCell>
                    <TableCell align="right">{upr.count}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
    </>
  );
};
